import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from '../../../components/AuthGuard';
import SettlementLayout from './layouts/SettlementLayout';
import VoucherClearingPage from './VoucherClearingPage';
import VoucherClearingLogPage from './VoucherClearingLogPage';
import SettlementBillMainPage from './SettlementBillMainPage';
import SettlementBillDetail from './SettlementBillDetail';
import RevenueInvoicePreviewPage from './RevenueInvoicePreviewPage';
import DspSettlementBillDetail from './DspSettlementBillDetail';
import SettlementBillRerun from './SettlementBillRerun';
import BillingPeriodOverviewPage from './BillingPeriodOverviewPage';
import BillingTestPage from './BillingTestPage';
import BillingConfigPage from './BillingConfigPage';
import PricingQueryPage from './PricingQueryPage';
import WorkflowAdjustmentReviewPage from './WorkflowAdjustmentReviewPage';
import WorkflowAdjustmentReviewDetailPage from './WorkflowAdjustmentReviewDetailPage';
import AccountManagementMainPage from './account/AccountManagementMainPage';
import RealtimeInvoiceDetailPage from './account/RealtimeInvoiceDetailPage';
import AccountTransactionFlowPage from './account/AccountTransactionFlowPage';
import VirtualAccountPage from './account/VirtualAccountPage';
import PricingMainPage from '../pricing/PricingMainPage';
import SettlementFeeItemPage from "./SettlementFeeItemPage";
import BillExportTemplateConfigPage from './BillExportTemplateConfigPage';
import PricingFailureExportPage from "../revise/PricingFailureExportPage";
import PreBillRevisionPage from "../revise/PreBillRevisionPage";
import BillingPeriodIncomeStatisticsPage from "./BillingPeriodIncomeStatisticsPage";
import RealtimeIncomeStatisticsPage from "./RealtimeIncomeStatisticsPage";
import DspExpenseStatisticsPage from "./DspExpenseStatisticsPage";
import SettlementImportDataPage from "pages/ops-tool/settlement/importData/SettlementImportDataPage";

const SettlementRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><SettlementLayout /></AuthGuard>}>
                <Route path="clearing-voucher" element={<VoucherClearingPage />} />
                <Route path="clearing-log" element={<VoucherClearingLogPage />} />
                <Route path="bill-list" element={<SettlementBillMainPage />} />
                <Route path="bill-detail/:billId" element={<SettlementBillDetail />} />
                <Route path="bill-detail/:billId/invoice" element={<RevenueInvoicePreviewPage />} />
                <Route path="dsp-bill-detail/:billId" element={<DspSettlementBillDetail />} />
                <Route path="bill-rerun" element={<SettlementBillRerun />} />
                <Route path="billing-period-overview" element={<BillingPeriodOverviewPage />} />
                <Route path="billing-test" element={<BillingTestPage />} />
                <Route path="billing-config" element={<BillingConfigPage />} />
                <Route path="pricing-query" element={<PricingQueryPage />} />
                <Route path="adjustment-review" element={<WorkflowAdjustmentReviewPage />} />
                <Route path="adjustment-review/:instanceId/:bizId" element={<WorkflowAdjustmentReviewDetailPage />} />
                <Route path="account/account-management" element={<AccountManagementMainPage />} />
                <Route path="account/realtime-invoice/:settlementClientId" element={<RealtimeInvoiceDetailPage />} />
                <Route path="account/transaction-flow" element={<AccountTransactionFlowPage />} />
                <Route path="account/virtual-account" element={<VirtualAccountPage />} />
                <Route path="price-center" element={<PricingMainPage />} />
                <Route path="fee-item-management" element={<SettlementFeeItemPage />} />
                <Route path="bill-export-template-config" element={<BillExportTemplateConfigPage />} />
                <Route path="revise/pricing-failure-export" element={<PricingFailureExportPage />} />
                <Route path="revise/pre-bill-revision" element={<PreBillRevisionPage />} />
                <Route path="import-data" element={<SettlementImportDataPage />} />
                <Route path="billing-period-income-statistics" element={<BillingPeriodIncomeStatisticsPage />} />
                <Route path="realtime-income-statistics" element={<RealtimeIncomeStatisticsPage />} />
                <Route path="dsp-expense-statistics" element={<DspExpenseStatisticsPage />} />
            </Route>
        </Routes>
    );
};

export default SettlementRoutes;
